/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

import { Component } from "react";
import PropTypes from "prop-types";
import React from "react";
import styled from "styled-components";
import { injectIntl, FormattedMessage } from "react-intl";
import { intl } from "../../services/intlGlobalProvider";
import { IoIosClose } from "react-icons/io";
import { ReactHeight } from "react-height";
import { Accordion, Checkbox, List, Icon } from "antd-mobile";
import connect from "react-redux/es/connect/connect";
import * as _ from "underscore";
import Stepper from "../../components/Stepper";
import AddToCartButton from "../../components/AddToCartButton";
import NavBar from "../../components/NavBar";
import DeliveryCheckbox from "../../components/DeliveryCheckbox";
import LoadingIndicator from "../../components/LoadingIndicator";
import Toast from "../../utils/Toast";
import Color from "../../utils/Color";
import * as selectors from "../../selectors";
import * as userAction from "../../actions/user";
import * as variantSelectors from "../../selectors/variant";
import * as orderSelectors from "../../selectors/addOn";
import * as userSelectors from "../../selectors/user";
import "./index.css";
import Theme from "../../utils/Theme";

const StyledContainer = styled.div`
  background: #f4f4f4;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  overflow: hidden;
`;

const StyledMainContainer = styled.div`
  margin-top: ${props => (props.transparentMode ? "unset" : "4.1em")};
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  overflow-x: hidden;
  overflow-y: scroll;
`;

const StyledTitleContainer = styled.div`
  background: white;
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-shrink: 0;
  justify-content: flex-start;
  align-items: center;
`;

const StyledTitle = styled.span`
  padding: 15px;
  width: 60%;
  text-align: start;
  font-size: 1em;
  color: black;
`;

const StyledPrice = styled.span`
  padding: 15px;
  width: 40%;
  text-align: end;
  font-weight: 800;
  font-size: 1.1em;
  color: black;
`;

const StyledSelectionTitle = styled.span`
  flex-shrink: 0;
  align-self: flex-start;
  padding: 15px 20px;
  text-align: start;
  font-weight: bold;
  font-size: 0.8em;
  color: gray;
  text-transform: uppercase;
`;

const StyledAddToCartBar = styled.div`
  width: 100%;
  background: white;
  box-shadow: 0 -3px 6px -5px grey;
  z-index: 10;
`;

const StyledAddToCartContent = styled.div`
  padding: 15px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const StyledMandataoryTxt = styled.span`
  font-weight: bold;
  color: #fff;
  margin-left: 5px;
  font-size: 0.8em;
`;

const StyledOptionHeader = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

const StyledOptionalTxt = styled.span`
  color: #fff;
  margin-left: 5px;
  font-size: 0.8em;
  font-weight: bold;
`;

const StyledOptionalTick = styled.span`
  color: #fff;
  font-weight: bold;
  flex: 1;
  display: flex;
  justify-content: flex-end;
`;

const StyledOptionItemContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  color: grey !important;
  font-size: 0.75em;
  line-height: 1.2em;
`;

const StyledOptionItemHeader = styled.div`
  width: 67%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const StyledVariantContainer = styled.div`
  width: 100%;
  background: #fff;
`;

const StyledVariantTitle = styled.div`
  background: ${Theme.PrimaryColor};
  color: #fff;
  padding: 15px;
  font-weight: bold;
`;

const StyledVariantItem = styled.div`
  padding: 10px 15px;
`;

class EditCartFoodPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      animationClass: null,
      navbarHeight: 0,
      imageHeight: 0,
      scrolledPosition: 0,
      selectedVariant: [],
      selectedAddOn: [],
      quantity: 1,
      isTakeAway: false
    };
  }

  componentDidMount() {
    const {
      showTabbar,
      showNavbar,
      userCartFoodDetailData,
      userCartItem
    } = this.props;

    if (userCartItem == null) {
      this.fetchUserCartItemData();
    } else {
      if (userCartFoodDetailData) {
        this.setAddOnAndVariantState(userCartFoodDetailData);
      }
    }

    showNavbar(false);
    showTabbar(false);
    this.setState({ animationClass: "slide-in-down" });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.updateCartStatus !== nextProps.updateCartStatus) {
      if (nextProps.updateCartStatus) {
        this.props.history.goBack();
      }
    }

    if (
      this.props.userCartFoodDetailData == null &&
      nextProps.userCartFoodDetailData != null
    ) {
      this.setAddOnAndVariantState(nextProps.userCartFoodDetailData);
    }
  }

  fetchUserCartItemData = () => {
    const { getUserCartItemRequest } = this.props;

    getUserCartItemRequest();
  };

  onBackPressed = () => {
    const { history } = this.props;
    this.setState({ animationClass: "slide-out-down" });

    window.setTimeout(() => {
      history.goBack();
    }, 300);
  };

  setAddOnAndVariantState = foodDetailData => {
    const variantData = userSelectors.getUserCartItemStallItemVariants(
      foodDetailData
    );
    const addOnData = userSelectors.getUserCartItemStallItemAddOns(
      foodDetailData
    );
    const quantity = userSelectors.getUserCartItemStallItemQuantity(
      foodDetailData
    );
    const isTakeAway = userSelectors.getUserCartItemStallItemIsTakeAway(
      foodDetailData
    );
    let newSelectedVariant = [];
    let newSelectedAddOn = [];

    variantData &&
      variantData.map(variant => {
        const variantItem = variantSelectors.getVariantItems(variant);
        const variantID = variantSelectors.getVariantID(variant);
        let newVariantItem = {
          id: variantID
        };
        variantItem &&
          variantItem.map(variantItem => {
            const variantItemIsSelected = variantSelectors.getVariantItemIsSelected(
              variantItem
            );
            const variantItemID = variantSelectors.getVariantItemID(
              variantItem
            );
            if (variantItemIsSelected) {
              newVariantItem = {
                id: variantID,
                item_id: variantItemID
              };
            }
          });
        newSelectedVariant.push(newVariantItem);
      });

    addOnData.map(addOn => {
      let newAddOnItem = {
        id: addOn.id,
        quantity: addOn.quantity
      };
      newSelectedAddOn.push(newAddOnItem);
    });

    this.setState({
      selectedVariant: newSelectedVariant,
      selectedAddOn: newSelectedAddOn,
      quantity: quantity,
      isTakeAway: isTakeAway
    });
  };

  onPressTakeAway = isChecked => {
    this.setState({
      isTakeAway: isChecked
    });
  };

  onQuantityChanged = qty => {
    this.setState({
      quantity: qty
    });
  };

  onPressVariantFood = (variantItemId, variantId) => {
    const { selectedVariant } = this.state;

    let newSelectedVariant =
      selectedVariant &&
      selectedVariant.map(variant => {
        if (variant.id === variantId) {
          return {
            id: variantId,
            item_id: variantItemId
          };
        } else {
          return variant;
        }
      });
    this.setState({
      selectedVariant: newSelectedVariant
    });
  };

  onChangeAddOnFood = (addOnItemId, value) => {
    const { selectedAddOn } = this.state;

    let newSelectedAddOn =
      selectedAddOn &&
      selectedAddOn.map(addOn => {
        if (addOn.id === addOnItemId) {
          return {
            id: addOnItemId,
            quantity: value
          };
        } else {
          return addOn;
        }
      });

    this.setState({
      selectedAddOn: newSelectedAddOn
    });
  };

  onPressAddToCart = () => {
    const { editUserCartFoodRequest } = this.props;
    const { selectedVariant, selectedAddOn, quantity, isTakeAway } = this.state;

    let variantResult = [];
    let checkVariant = true;
    selectedVariant.map(variant => {
      if (variant && variant.item_id === undefined) {
        checkVariant = false;
      } else {
        variantResult.push(variant);
      }
    });
    let addOnResult = selectedAddOn.filter(addOn => addOn.quantity > 0);
    if (checkVariant) {
      let submitData = {
        variants: variantResult,
        addons: addOnResult,
        quantity: quantity,
        is_take_away: isTakeAway
      };
      editUserCartFoodRequest(this.getCurrentFoodID(), submitData);
    } else {
      Toast.error(
        intl.formatMessage({ id: "product.selection.empty.variant" })
      );
    }
  };

  isReachNavbarBottom = () => {
    const { navbarHeight, imageHeight, scrolledPosition } = this.state;

    if (navbarHeight === 0 || imageHeight === 0) {
      return false;
    }
    return scrolledPosition > imageHeight - navbarHeight;
  };

  isTransparentMode = imgSrc => {
    return !(imgSrc === null || imgSrc === "");
  };

  getCurrentFoodID = () => {
    const { match } = this.props;
    return match && match.params ? match.params.id : null;
  };

  getDistanceBetweenNavbar = () => {
    const { navbarHeight, imageHeight, scrolledPosition } = this.state;

    if (navbarHeight === 0 || imageHeight === 0) {
      return 10;
    }

    let result = Math.round(
      (scrolledPosition / (imageHeight - navbarHeight)) * 10
    );

    if (result < 0) {
      return 0;
    }

    if (result > 10) {
      return 10;
    }

    return result;
  };

  getOptionsItemHeader = (title, mandatory, showCompleted = false) => {
    return (
      <StyledOptionHeader>
        <span>{title}</span>
        {mandatory ? (
          <StyledMandataoryTxt>
            (
            {
              <FormattedMessage
                id="product.selection.mandatory.title"
                defaultMessage="Mandatory"
                description="Product Selection Mandatory Title"
              />
            }
            )
          </StyledMandataoryTxt>
        ) : (
          <StyledOptionalTxt>
            (
            {
              <FormattedMessage
                id="product.selection.optional.title"
                defaultMessage="Optional"
                description="Product Selection Optional Title"
              />
            }
            )
          </StyledOptionalTxt>
        )}
        {showCompleted ? (
          <StyledOptionalTick>
            <Icon
              style={{ marginLeft: "15px" }}
              type="check-circle-o"
              color={Color.lightTextColor}
              size="xxs"
            />
          </StyledOptionalTick>
        ) : null}
      </StyledOptionHeader>
    );
  };

  getOptionsItem = () => {
    const { userCartFoodDetailData } = this.props;
    const { selectedVariant, selectedAddOn } = this.state;
    const variantData = userSelectors.getUserCartItemStallItemVariants(
      userCartFoodDetailData
    );
    const addOnData = userSelectors.getUserCartItemStallItemAddOns(
      userCartFoodDetailData
    );
    const addOnAdded = [
      {
        addOnData
      }
    ];

    return (
      <StyledVariantContainer>
        {/*Varaint Section*/}
        {variantData.map(variant => {
          const variantID = variantSelectors.getVariantID(variant);
          const variantItems = variantSelectors.getVariantItems(variant);
          const variantTitle = variantSelectors.getVariantName(variant);
          const variantSelected = _.find(selectedVariant, selectedVariant => {
            return selectedVariant.id === variant.id;
          });

          return (
            <StyledVariantContainer>
              <StyledVariantTitle>
                {this.getOptionsItemHeader(
                  variantTitle,
                  true,
                  !!(variantSelected && variantSelected.item_id)
                )}
              </StyledVariantTitle>
              {variantItems.map(variantItem => {
                const variantItemId = variantSelectors.getVariantItemID(
                  variantItem
                );
                const variantItemTitle = variantSelectors.getVariantItemName(
                  variantItem
                );
                const variantItemPriceText = variantSelectors.getVariantItemPriceText(
                  variantItem
                );

                return (
                  <Checkbox.CheckboxItem
                    className={"product-selection-checkbox"}
                    key={variantItemId}
                    checked={
                      !!(
                        variantSelected &&
                        variantSelected.item_id === variantItemId
                      )
                    }
                    onChange={() =>
                      this.onPressVariantFood(variantItemId, variantID)
                    }
                  >
                    <StyledOptionItemContainer
                      onClick={() =>
                        this.onPressVariantFood(variantItemId, variantID)
                      }
                    >
                      <span>{variantItemTitle}</span>
                      <span style={{ color: "black" }}>
                        {variantItemPriceText}
                      </span>
                    </StyledOptionItemContainer>
                  </Checkbox.CheckboxItem>
                );
              })}
            </StyledVariantContainer>
          );
        })}
        {/*Add On Section*/}
        {addOnData && addOnData.length > 0 ? (
          <StyledVariantContainer>
            <StyledVariantTitle>
              {this.getOptionsItemHeader(
                <FormattedMessage id="product.selection.addon.title" />,
                false,
                !!addOnAdded
              )}
            </StyledVariantTitle>
            <StyledVariantContainer className={"addonoptions"}>
              {addOnData.map(addOnItem => {
                const { selectedAddOn } = this.state;
                const addOnItemId = orderSelectors.getAddOnID(addOnItem);
                const addOnItemName = orderSelectors.getAddOnName(addOnItem);
                const addOnItemPriceText = orderSelectors.getAddOnPriceText(
                  addOnItem
                );
                const selectedAddOnItem = _.find(selectedAddOn, obj => {
                  return obj.id === addOnItemId;
                });
                const selectedAddOnItemQty =
                  selectedAddOnItem && selectedAddOnItem.quantity
                    ? selectedAddOnItem.quantity
                    : 0;

                return (
                  <StyledVariantItem>
                    <StyledOptionItemContainer>
                      <StyledOptionItemHeader>
                        <span>{addOnItemName}</span>
                        <span style={{ color: "black" }}>
                          {addOnItemPriceText}
                        </span>
                      </StyledOptionItemHeader>
                      <Stepper
                        value={selectedAddOnItemQty}
                        onChange={value =>
                          this.onChangeAddOnFood(addOnItemId, value)
                        }
                      />
                    </StyledOptionItemContainer>
                  </StyledVariantItem>
                );
              })}
            </StyledVariantContainer>
          </StyledVariantContainer>
        ) : null}
      </StyledVariantContainer>
    );
  };

  getLoadingIndicator = () => {
    const { userCartLoading, updateCartLoading } = this.props;

    return userCartLoading || updateCartLoading ? <LoadingIndicator /> : null;
  };

  render() {
    const { animationClass, quantity, isTakeAway } = this.state;
    const { location, history, match, userCartFoodDetailData } = this.props;

    const title = userSelectors.getUserCartItemStallItemTitle(
      userCartFoodDetailData
    );
    const price = userSelectors.getUserCartItemStallItemTotalPriceWithCurrency(
      userCartFoodDetailData
    );
    const defaultImageSrc = userSelectors.getUserCartItemStallItemImageLargeSrc(
      userCartFoodDetailData
    );
    const allowTakeAway = userSelectors.getUserCartItemStallItemIsAllowTakeAway(
      userCartFoodDetailData
    );
    const foodTakeAwaysPrice = userSelectors.getUserCartItemStallItemTakeAwayText(
      userCartFoodDetailData
    );
    const isCheckOutable = userSelectors.getUserCartItemStallItemIsCheckoutable(
      userCartFoodDetailData
    );

    return (
      <StyledContainer
        className={animationClass !== null ? animationClass : false}
        onAnimationEnd={() => this.setState({ animationClass: null })}
      >
        <ReactHeight
          onHeightReady={height => this.setState({ navbarHeight: height })}
          style={{ position: "absolute", width: "0", height: "3.6em" }}
        />
        <NavBar
          className={"nav-opacity-" + this.getDistanceBetweenNavbar()}
          middleTitle={
            <FormattedMessage
              id="product.selection.title"
              defaultMessage="Customise"
              description="Product Selection Title"
            />
          }
          history={history}
          location={location}
          match={match}
          leftIcon={<IoIosClose size={"1.7em"} />}
          onLeftIconClick={() => this.onBackPressed()}
          transparentMode={
            this.isTransparentMode(defaultImageSrc) &&
            !this.isReachNavbarBottom()
          }
        />
        <StyledMainContainer
          onScroll={evt =>
            this.setState({
              scrolledPosition: evt.nativeEvent.target.scrollTop
            })
          }
          transparentMode={this.isTransparentMode(defaultImageSrc)}
        >
          {this.getLoadingIndicator()}
          {defaultImageSrc &&
          defaultImageSrc !== "" &&
          defaultImageSrc !== null ? (
            <img
              ref={ref => (this.itemImage = ref)}
              src={defaultImageSrc}
              alt=""
              style={{
                height: "40%",
                width: "100%",
                objectFit: "cover"
              }}
              onLoad={() => {
                window.dispatchEvent(new Event("resize"));
                this.setState({ imageHeight: this.itemImage.height });
              }}
            />
          ) : null}
          <StyledTitleContainer>
            <StyledTitle>{title}</StyledTitle>
            <StyledPrice>{price}</StyledPrice>
          </StyledTitleContainer>
          <StyledSelectionTitle>
            <FormattedMessage
              id="product.selection.subtitle"
              defaultMessage="Customise Your Order"
              description="Product Selection SubTitle"
            />
          </StyledSelectionTitle>
          {this.getOptionsItem()}
        </StyledMainContainer>
        <StyledAddToCartBar>
          <StyledAddToCartContent>
            <Stepper
              minStep={1}
              maxStep={20}
              value={quantity}
              onChange={num => this.onQuantityChanged(num)}
            />
            <DeliveryCheckbox
              isChecked={isTakeAway}
              disabled={!allowTakeAway}
              price={foodTakeAwaysPrice}
              onClicked={isCheck => this.onPressTakeAway(isCheck)}
            />
            <AddToCartButton
              disabled={!isCheckOutable}
              displayText={intl.formatMessage({ id: "app.update" })}
              showText
              textOnly
              onClicked={() => this.onPressAddToCart()}
            />
          </StyledAddToCartContent>
        </StyledAddToCartBar>
      </StyledContainer>
    );
  }
}

EditCartFoodPage.propTypes = {
  showNavbar: PropTypes.func.isRequired,
  showTabbar: PropTypes.func.isRequired,
  navbarConfig: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  intl: PropTypes.object,
  authToken: PropTypes.string,
  userCartItem: PropTypes.object,
  userCartLoading: PropTypes.bool,
  updateCartLoading: PropTypes.bool,
  updateCartStatus: PropTypes.bool,
  userCartFoodDetailData: PropTypes.object,
  getUserCartItemRequest: PropTypes.func,
  editUserCartFoodRequest: PropTypes.func
};

EditCartFoodPage.defaultProps = {};

function mapStateToProps(state, props) {
  const { match } = props;
  const cartFoodId = match && match.params ? match.params.id : null;

  return {
    authToken: selectors.getAuthToken(state),
    userCartLoading: selectors.getUserCartLoading(state),
    userCartItem: selectors.getUserCartItem(state),
    updateCartLoading: selectors.getUpdateCartFoodLoading(state),
    updateCartStatus: selectors.getUpdateCartFoodStatus(state),
    userCartFoodDetailData: selectors.getUserCartItemStallItem(
      state,
      cartFoodId
    )
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getUserCartItemRequest: () => dispatch(userAction.getUserCartItemRequest()),
    editUserCartFoodRequest: (cartID, foodData) =>
      dispatch(userAction.editUserCartFoodRequest(cartID, foodData))
  };
}

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(EditCartFoodPage)
);



// WEBPACK FOOTER //
// ./src/containers/EditCartFoodPage/index.js